import { object } from "yup";
import { FormField } from "./types";
import { useRecipientsPivotValidationSchema } from "../shared";

const useValidationSchema = () =>
    useRecipientsPivotValidationSchema()
        .concat(
            object().shape({
                [FormField.RegReportingCodes]: object()
                    .nullable()
                    .label('Reg Reporting Codes')
            })
        );

export default useValidationSchema;
